import { Link } from "react-router-dom";

const PrivacyPolicyInner = () => {
  return (
    <section className='privacy-policy py-120'>
      <div className='container'>
        <div className='row gy-4'>
          <div className='col-lg-8'>
            <div className='d-flex flex-column gap-40'>
              <div className=''>
                <h1 className='mb-16'>Information We Collect</h1>
                <p className='text-neutral-700'>
                  Thank you for choosing EduAll! Your privacy is important to
                  us, and we are committed to protecting your personal
                  information. This Privacy Policy explains how EduAll collects,
                  uses, discloses, and safeguards your information when you use
                  our education and online course platform, including any
                  community features.
                </p>
              </div>
              <div className=''>
                <h3 className='mb-16'>Account Information:</h3>
                <ul className='list-dotted d-flex flex-column gap-24'>
                  <li className='text-neutral-700'>
                    {" "}
                    When you create an account, we collect your name, email
                    address, and other necessary details to create and manage
                    your account.
                  </li>
                  <li className='text-neutral-700'>
                    {" "}
                    We implement security measures to protect your information
                    from unauthorized access, disclosure, alteration, or
                    destruction.
                  </li>
                </ul>
              </div>
              <div className=''>
                <h4 className='mb-16'>Course Enrollment:</h4>
                <ul className='list-dotted d-flex flex-column gap-24'>
                  <li className='text-neutral-700'>
                    If you enroll in a course, we collect information related to
                    your course progress, performance, and completion.
                  </li>
                  <li className='text-neutral-700'>
                    You can opt-out of promotional emails, but we will still
                    send essential communications related to your account and
                    courses.
                  </li>
                </ul>
              </div>
              <div className=''>
                <h5 className='mb-16'>Community Participation:</h5>
                <ul className='list-dotted d-flex flex-column gap-24'>
                  <li className='text-neutral-700'>
                    When you engage in community discussions or forums, we
                    collect information related to your posts, comments, and
                    interactions with other users.
                  </li>
                </ul>
              </div>
              <div className=''>
                <h6 className='mb-16'> Payment Information:</h6>
                <ul className='list-dotted d-flex flex-column gap-24'>
                  <li className='text-neutral-700'>
                    {" "}
                    If you make a purchase, we collect payment information, such
                    as credit card details, to process transactions securely.
                  </li>
                  <li className='text-neutral-700'>
                    {" "}
                    We may update this Privacy Policy periodically, and any
                    changes will be posted on this page. It's your
                    responsibility to review the policy for updates.
                  </li>
                </ul>
              </div>
            </div>
            <p className='text-neutral-700 mt-32'>
              Please remember to replace "Date" and "Contact" with the actual
              date and contact information for your platform. Additionally,
              ensure that the policy aligns with the legal requirements
              applicable to your region.
            </p>
          </div>
          <div className='col-lg-4'>
            <div className='border border-neutral-30 rounded-12 bg-main-25 p-32 bg-main-25'>
              <h4 className='mb-16'>More Some Policy</h4>
              <span className='d-block border border-neutral-30 my-24 border-dashed' />
              <div className='d-flex align-items-center justify-content-between gap-24'>
                <div className='d-flex align-items-center gap-16'>
                  <span className='w-56 h-56 rounded-circle bg-white border border-neutral-30 d-flex justify-content-center align-items-center text-neutral-500 text-2xl'>
                    <i className='ph ph-file-text' />
                  </span>
                  <div>
                    <h6 className='text-xl mb-8 fw-medium'>Personalization</h6>
                    <span className='text-neutral-500 text-sm'>
                      Download &amp; view our Policy
                    </span>
                  </div>
                </div>
                <button
                  type='button'
                  className='w-56 h-56 rounded-circle bg-white border border-neutral-30 d-flex justify-content-center align-items-center text-neutral-500 text-2xl hover-bg-main-600 hover-border-main-600 hover-text-white'
                >
                  <i className='ph ph-download-simple' />
                </button>
              </div>
              <span className='d-block border border-neutral-30 my-24 border-dashed' />
              <div className='d-flex align-items-center justify-content-between gap-24'>
                <div className='d-flex align-items-center gap-16'>
                  <span className='w-56 h-56 rounded-circle bg-white border border-neutral-30 d-flex justify-content-center align-items-center text-neutral-500 text-2xl'>
                    <i className='ph ph-file-text' />
                  </span>
                  <div>
                    <h6 className='text-xl mb-8 fw-medium'>Communication</h6>
                    <span className='text-neutral-500 text-sm'>
                      Download &amp; view our Policy
                    </span>
                  </div>
                </div>
                <button
                  type='button'
                  className='w-56 h-56 rounded-circle bg-white border border-neutral-30 d-flex justify-content-center align-items-center text-neutral-500 text-2xl hover-bg-main-600 hover-border-main-600 hover-text-white'
                >
                  <i className='ph ph-download-simple' />
                </button>
              </div>
              <span className='d-block border border-neutral-30 my-24 border-dashed' />
              <div className='d-flex align-items-center justify-content-between gap-24'>
                <div className='d-flex align-items-center gap-16'>
                  <span className='w-56 h-56 rounded-circle bg-white border border-neutral-30 d-flex justify-content-center align-items-center text-neutral-500 text-2xl'>
                    <i className='ph ph-file-text' />
                  </span>
                  <div>
                    <h6 className='text-xl mb-8 fw-medium'>Analytics</h6>
                    <span className='text-neutral-500 text-sm'>
                      Download &amp; view our Policy
                    </span>
                  </div>
                </div>
                <button
                  type='button'
                  className='w-56 h-56 rounded-circle bg-white border border-neutral-30 d-flex justify-content-center align-items-center text-neutral-500 text-2xl hover-bg-main-600 hover-border-main-600 hover-text-white'
                >
                  <i className='ph ph-download-simple' />
                </button>
              </div>
              <span className='d-block border border-neutral-30 my-24 border-dashed' />
              <div className='d-flex align-items-center justify-content-between gap-24'>
                <div className='d-flex align-items-center gap-16'>
                  <span className='w-56 h-56 rounded-circle bg-white border border-neutral-30 d-flex justify-content-center align-items-center text-neutral-500 text-2xl'>
                    <i className='ph ph-file-text' />
                  </span>
                  <div>
                    <h6 className='text-xl mb-8 fw-medium'>
                      Sharing Your Info
                    </h6>
                    <span className='text-neutral-500 text-sm'>
                      Download &amp; view our Policy
                    </span>
                  </div>
                </div>
                <button
                  type='button'
                  className='w-56 h-56 rounded-circle bg-white border border-neutral-30 d-flex justify-content-center align-items-center text-neutral-500 text-2xl hover-bg-main-600 hover-border-main-600 hover-text-white'
                >
                  <i className='ph ph-download-simple' />
                </button>
              </div>
              <span className='d-block border border-neutral-30 my-24 border-dashed' />
              <div className='d-flex align-items-center justify-content-between gap-24'>
                <div className='d-flex align-items-center gap-16'>
                  <span className='w-56 h-56 rounded-circle bg-white border border-neutral-30 d-flex justify-content-center align-items-center text-neutral-500 text-2xl'>
                    <i className='ph ph-file-text' />
                  </span>
                  <div>
                    <h6 className='text-xl mb-8 fw-medium'>Service Provider</h6>
                    <span className='text-neutral-500 text-sm'>
                      Download &amp; view our Policy
                    </span>
                  </div>
                </div>
                <button
                  type='button'
                  className='w-56 h-56 rounded-circle bg-white border border-neutral-30 d-flex justify-content-center align-items-center text-neutral-500 text-2xl hover-bg-main-600 hover-border-main-600 hover-text-white'
                >
                  <i className='ph ph-download-simple' />
                </button>
              </div>
              <span className='d-block border border-neutral-30 my-24 border-dashed' />
              <div className='d-flex align-items-center justify-content-between gap-24'>
                <div className='d-flex align-items-center gap-16'>
                  <span className='w-56 h-56 rounded-circle bg-white border border-neutral-30 d-flex justify-content-center align-items-center text-neutral-500 text-2xl'>
                    <i className='ph ph-file-text' />
                  </span>
                  <div>
                    <h6 className='text-xl mb-8 fw-medium'>Security</h6>
                    <span className='text-neutral-500 text-sm'>
                      Download &amp; view our Policy
                    </span>
                  </div>
                </div>
                <button
                  type='button'
                  className='w-56 h-56 rounded-circle bg-white border border-neutral-30 d-flex justify-content-center align-items-center text-neutral-500 text-2xl hover-bg-main-600 hover-border-main-600 hover-text-white'
                >
                  <i className='ph ph-download-simple' />
                </button>
              </div>
              <span className='d-block border border-neutral-30 my-24 border-dashed' />
              <Link
                to='/sign-in'
                className='h6 mb-0 text-main-600 fw-semibold hover-text-decoration-underline'
              >
                See All
                <i className='ph-bold ph-arrow-right' />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PrivacyPolicyInner;
